import React from 'react';

const MessageList = ({ messages, isLoading, messagesEndRef }) => {
  return (
    <div className="messages-container">
      {messages.map(message => (
        <div key={message.id} className={`message-wrapper ${message.sender}`}>
          <div className="message-content">
            <div className="message-avatar">
              {message.sender === 'user' ? 'U' :
               message.sender === 'system' ? '🤖' : 'AI'}
            </div>
            <div className="message-text">
              <div style={{ whiteSpace: 'pre-wrap' }}>
                {message.text}
              </div>
              {message.uploadedImages && message.uploadedImages.length > 0 && (
                <div className="uploaded-images-container">
                  {message.uploadedImages.map((image, index) => (
                    <div key={index} className="uploaded-image-wrapper">
                      <img
                        src={image.dataUrl}
                        alt={image.name}
                        className="uploaded-image"
                        onLoad={() => console.log(`Image loaded: ${image.name}`)}
                        onError={(e) => console.error(`Failed to load image: ${image.name}`, e)}
                      />
                      <div className="image-caption">
                        {image.name}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {message.type === 'image' && message.imageElement && (
                <div className="generated-image-container">
                  <div ref={(el) => {
                    if (el && message.imageElement && !el.hasChildNodes()) {
                      el.appendChild(message.imageElement);
                    }
                  }} />
                </div>
              )}
              {message.gpt4freeImageUrl && (
                <div className="generated-image-container">
                  <img
                    src={message.gpt4freeImageUrl}
                    alt="GPT4Free generated image"
                    className="generated-image"
                    onLoad={() => console.log('GPT4Free image loaded')}
                    onError={(e) => console.error('Failed to load GPT4Free image:', e)}
                  />
                </div>
              )}
              {message.type === 'audio' && message.audioStream && (
                <div className="generated-audio-container">
                  <audio
                    controls
                    autoPlay
                    preload="metadata"
                    ref={(el) => {
                      if (el && message.audioStream && !el.src) {
                        try {
                          if (message.audioStream instanceof Blob) {
                            const blobUrl = URL.createObjectURL(message.audioStream);
                            el.src = blobUrl;
                          } else if (typeof message.audioStream === 'string') {
                            el.src = message.audioStream;
                          } else if (message.audioStream.src) {
                            el.src = message.audioStream.src;
                          }
                        } catch (error) {
                          console.error('Error setting up audio:', error);
                        }
                      }
                    }}
                    onLoadStart={() => console.log('Audio loading started')}
                    onCanPlay={() => console.log('Audio can play')}
                    onError={(e) => console.error('Audio error:', e.target.error)}
                  >
                    Your browser does not support the audio element.
                  </audio>
                  <div className="audio-info">
                    <small>Generated speech audio</small>
                    {message.audioStream && (
                      <div className="audio-controls">
                        <button
                          className="download-audio-btn"
                          onClick={async () => {
                            try {
                              let downloadUrl = null;
                              let filename = `speech-audio-${Date.now()}.mp3`;

                              console.log('Starting audio download for:', typeof message.audioStream);

                              if (message.audioStream instanceof Blob) {
                                console.log('Audio is Blob, size:', message.audioStream.size);
                                downloadUrl = URL.createObjectURL(message.audioStream);
                              } else if (message.audioStream instanceof ReadableStream) {
                                console.log('Audio is ReadableStream, converting to blob...');
                                // Convert ReadableStream to Blob
                                const reader = message.audioStream.getReader();
                                const chunks = [];
                                let done = false;

                                while (!done) {
                                  const { value, done: streamDone } = await reader.read();
                                  if (streamDone) {
                                    done = true;
                                  } else {
                                    chunks.push(value);
                                  }
                                }

                                const blob = new Blob(chunks, { type: 'audio/mpeg' });
                                downloadUrl = URL.createObjectURL(blob);
                                console.log('Converted stream to blob, size:', blob.size);
                              } else if (typeof message.audioStream === 'string') {
                                console.log('Audio is string URL:', message.audioStream);
                                downloadUrl = message.audioStream;
                              } else if (message.audioStream && message.audioStream.src) {
                                console.log('Audio has src property:', message.audioStream.src);
                                downloadUrl = message.audioStream.src;
                              }

                              if (downloadUrl) {
                                console.log('Creating download link for:', downloadUrl);
                                const a = document.createElement('a');
                                a.href = downloadUrl;
                                a.download = filename;
                                a.style.display = 'none';

                                document.body.appendChild(a);
                                a.click();
                                document.body.removeChild(a);

                                console.log('Download initiated successfully');

                                // Clean up blob URLs
                                if (message.audioStream instanceof Blob || message.audioStream instanceof ReadableStream) {
                                  setTimeout(() => {
                                    URL.revokeObjectURL(downloadUrl);
                                    console.log('Cleaned up blob URL');
                                  }, 1000);
                                }
                              } else {
                                console.error('No valid download URL available');
                                alert('Unable to download audio: No valid audio data available');
                              }
                            } catch (error) {
                              console.error('Download failed:', error);
                              alert('Download failed: ' + error.message);
                            }
                          }}
                        >
                          📥 Download Audio
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
      {isLoading && (
        <div className="message-wrapper bot">
          <div className="message-content">
            <div className="message-avatar bot">AI</div>
            <div className="message-text typing-indicator">Thinking...</div>
          </div>
        </div>
      )}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList;